@if (question.min && question.max) {
  <div class="range-slidecontainer">
    <img class="icon-value" [src]="'/assets/images/range-slider/'+image" id="icon-value">
    <input type="range" [min]="question.min" [max]="question.max" [value]="_value ? _value : question.min" class="range-slider"
      (change)="changeValue($event)" id="myRange">
    <p>Value: <span id="demo">{{_value ? _value : question.min}}</span></p>
  </div>
}